module.exports = __webpack_public_path__ + "img/icon-plus.635dd96e.svg";